import React, { useEffect } from "react"
import { withRouter } from "react-router-dom"
import { useSelector } from "react-redux"
import { useToggle } from "utils/Hooks"
import { Spacer } from "../../atoms/Atoms"
import { UpdateBankInfoModal } from "../../../containers/reimbursements/UpdateBankInfoModal"
import { ReimbursementsModalContainer } from "../../../containers/reimbursements/ReimbursementsModalContainer"
import { BenefitEnrollmentFlowContainer } from "../../../csd-enrollment"
import { getCarrotLite } from "reducers/companyInfo"
import { getNeedsBenefitEnrollment, getShouldFillOutBankInfo } from "derivedSelectors/index"
import L10n from "lib/carrot-l10n"
import { NavItem } from "./NavItem"
import { NavSection } from "./NavSection"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const BenefitsNav = withRouter(({ onClick, history, location }) => {
  const carrotLite = useSelector(getCarrotLite)
  const needsBenefitEnrollment = useSelector(getNeedsBenefitEnrollment)
  const shouldShowBankInfoModal = useSelector(getShouldFillOutBankInfo)
  const [isBankInfoModalOpen, toggleIsBankInfoModalOpen] = useToggle(false)
  const [isReimbursementsModalOpen, toggleIsReimbursementsModalOpen] = useToggle(false)
  const [isBenefitEnrollmentModalOpen, toggleBenefitEnrollmentModal] = useToggle(false)

  useEffect(() => {
    if (location.hash === "#needs-benefit-enrollment" && !isBenefitEnrollmentModalOpen) {
      location.hash = ""
      toggleBenefitEnrollmentModal()
    }

    if (location.hash === "#no-bank-info" && !isBankInfoModalOpen) {
      location.hash = ""
      toggleIsBankInfoModalOpen()
    }
  }, [location.hash, toggleIsBankInfoModalOpen, isBankInfoModalOpen])

  const onNavigateToTransactions = () => {
    if (needsBenefitEnrollment) {
      toggleBenefitEnrollmentModal()
    } else {
      history.push("/transactions")
    }
    onClick()
  }

  const onNavigateToUpload = () => {
    if (needsBenefitEnrollment) {
      toggleBenefitEnrollmentModal()
    } else if (shouldShowBankInfoModal) {
      toggleIsBankInfoModalOpen()
    } else {
      toggleIsReimbursementsModalOpen()
    }
    onClick()
  }

  const onCloseBenefitEnrollmentModal = () => {
    toggleBenefitEnrollmentModal()
    onClick()
  }

  const onCloseBankInfoModal = () => {
    toggleIsBankInfoModalOpen()
    onClick()
  }

  return (
    <>
      <NavSection iconName="icn-get-money" sectionLabel={l`client.chat.benefits.title`}>
        <NavItem
          id="nav-your-benefit-guide-link"
          link="/your-benefit-guide"
          text={l`Your benefit guide`}
          onClick={onClick}
        />
        {!carrotLite && (
          <>
            <Spacer height={1} />
            <NavItem
              onClickOnly
              exact
              id="nav-transactions-link"
              link={"/transactions"}
              text={l`client.transactions.navText`}
              onClick={onNavigateToTransactions}
            />
            <Spacer height={1} />
            <NavItem
              onClickOnly
              id="nav-get-reimbursed-link"
              link={"/reimbursements"}
              text={l`client.reimbursements.navText`}
              onClick={onNavigateToUpload}
            />
          </>
        )}
      </NavSection>

      {isBenefitEnrollmentModalOpen && <BenefitEnrollmentFlowContainer onExit={onCloseBenefitEnrollmentModal} />}

      {isBankInfoModalOpen && (
        <UpdateBankInfoModal onNavigateToAccountPage={onCloseBankInfoModal} onClose={toggleIsBankInfoModalOpen} />
      )}
      {isReimbursementsModalOpen && (
        <ReimbursementsModalContainer
          onClose={toggleIsReimbursementsModalOpen}
          onFinish={toggleIsReimbursementsModalOpen}
        />
      )}
    </>
  )
})

export { BenefitsNav }